<template>
  <Select
    v-model:value="value"
    show-search
    :placeholder="$lang('请输入')"
    style="display: flex"
    :default-active-first-option="false"
    :show-arrow="true"
    :filter-option="false"
    :not-found-content="null"
    :options="data"
    @search="handleSearch"
    @change="handleChange"
    :fieldNames="props.fieldNames"
    :allowClear="props.allowClear"
  ></Select>
</template>
<script lang="ts" setup>
  import { ref, watch } from 'vue'
  import { Select } from 'ant-design-vue'
  import { debounce } from 'lodash-es'
  import { useApi } from '@xinghai/site-common'
  type Props = {
    optionData?: []
    fieldNames: any
    value: string
    ajaxUrl: any
    params: string
    isJoin?: boolean
    allowClear?: boolean
  }
  const props = withDefaults(defineProps<Props>(), {
    isJoin: false,
    allowClear: true
  })
  const box_list = useApi(props.ajaxUrl)
  const data = ref<any[]>([])
  const value = ref(props.value)
  const emit = defineEmits(['update:value'])
  const handleSearch = debounce((val: string) => {
    if (!val.trim()) return
    box_list.fetchData({ [props['params']]: val }).then((res) => {
      data.value = (res.data || []).map((item: any) => {
        return {
          [props['fieldNames']['label']]:
            item[props.fieldNames.label] + (props.isJoin ? '(' + item[props.fieldNames.value] + ')' : ''),
          [props['fieldNames']['value']]: item[props.fieldNames.value],
          id: item.id
        }
      })
    })
  }, 300)
  watch(
    () => props.value,
    (c) => {
      value.value = c
    }
  )
  const handleChange = (val: string) => {
    value.value = val
    emit('update:value', val)
  }
  defineExpose({ handleSearch })
</script>
<style lang="less" scoped></style>
